/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgOutOfRangeHighSAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m12 23 11-11L12 1 1 12zm5.707-11.707-1.414 1.414L13 9.414V18h-2V9.414l-3.293 3.293-1.414-1.414L12 5.586z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgOutOfRangeHighSAlt as OutOfRangeHighSAlt };
